<template>
  <div class="page_home">
    <div class="home-header" style="height: 540px">
      <el-image style="width: 100%;height: 100%" :src="require('@/assets/images/header/header3.png')"></el-image>
    </div>
    <div class="home-main">
      <div class="home-content">
        <div class="jyxx">
          <div style="display: flex;justify-content: space-between;align-items: center;padding: 28px 0 ">
            <div v-for="(item,index) in logOn" :key="item.type">
              <el-image @click="goToLogin(item)" style="width: 240px;height: 92px"  :src="item.icon" fit="fill"></el-image>
            </div>
          </div>
        </div>
        <div class="jyxx">
          <div class="jyxx-header">
            <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 6px">
              <div style="width: 64px;height: 1px; background: #BEDBFF;"></div>
              <div style="font-size: 28px;color: #1E2939;margin: 0 16px">公告列表</div>
              <div style="width: 64px;height: 1px; background: #BEDBFF;"></div>
            </div>
            <div style="font-weight: 500;font-size: 16px;">List of announcements</div>
          </div>

          <div class="bj">
            <div style="font-size: 14px;color: #4A5565;cursor: pointer;box-sizing: border-box;display: flex;justify-content: left;align-items: center;margin-bottom: 22px">
              <div v-for="(item,index) in cgType" :key="item.value" style="padding: 6px 16px;box-sizing: border-box;;margin-right: 12px;border-radius: 4px 4px 4px 4px;"
                   :style="item.value === cgQueryParam.ggAnnouncement ? 'color: #FFFFFF;background: #155DFC;' : 'background: #F9FAFB;border: 1px solid #E5E7EB;'"
                   @click="cgSelect(item)">

                 {{ item.label }}

              </div>
            </div>
            <div style="margin: 22px 0 16px 0;border: 2px solid #F3F4F6;border-radius: 4px 4px 4px 4px;"></div>
            <div style="">
              <div class="jyxx-content">
                <div v-for="(item,index) in cgList" :key="item.id" @click="ggDetail(item)">
                  <div style="display: flex;justify-content: space-between;align-items:center ;margin-bottom: 16px;box-sizing: border-box">
                    <div style="display: flex;justify-content: left;align-items: center">
                      <div style="width: 6px;height: 6px;background: #51A2FF;border-radius:25px;margin-right: 8px"></div>
                      <div style="font-size: 16px;color: #333333;font-weight: 400;" v-if="item.areaName">【{{ item.areaName }}】</div>
                      <div style="font-size: 16px;color: #333333;font-weight: 400;">{{ item.ggName.length > 40 ? item.ggName.substring(0,40) + '...' : item.ggName }}</div>
                    </div>
                    <div style="font-size: 14px;color: #99A1AF;">{{ item.ggStartTime.substring(0,10) }} </div>
                  </div>
                </div>
              </div>
              <div class="jyxx-foot" @click="toPath('/about')">
                <div style="font-weight: 500;font-size: 14px;color: #155DFC;cursor: pointer;margin-right: 4px"  >查看更多</div>
                <el-image style="width: 14px;height: 14px;" :src="require('@/assets/images/public/rightJT.png')"></el-image>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="jyxx" style="display: flex;justify-content: space-between;align-items: center">-->
<!--          <el-image @click="toRouter('/bidEvaluationOffice')" style="width: 620px;height: 148px" :src="require('@/assets/images/homeImages/dzbh.png')"></el-image>-->
<!--          <el-image @click="toRouter('/expert')" style="width: 620px;height: 148px" :src="require('@/assets/images/homeImages/zjcq.png')"></el-image>-->

<!--        </div>-->

        <div class="jyxx" style="">
          <div class="jyxx-header">
            <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 6px">
              <div style="width: 64px;height: 1px; background: #BEDBFF;"></div>
              <div style="font-size: 28px;color: #1E2939;margin: 0 16px">中标信息</div>
              <div style="width: 64px;height: 1px; background: #BEDBFF;"></div>
            </div>
            <div style="font-weight: 500;font-size: 16px;">Bid winning information</div>
          </div>
          <div class="bj" style="">
            <div style="font-size: 14px;color: #4A5565;cursor: pointer;box-sizing: border-box;display: flex;justify-content: left;align-items: center;margin-bottom: 22px">
              <div v-for="(item,index) in zbType" :key="item.value" style="padding: 6px 16px;box-sizing: border-box;;margin-right: 12px;border-radius: 4px 4px 4px 4px;"
                   :style="item.value === zbQueryParam.ggAnnouncement ? 'color: #FFFFFF;background: #155DFC;' : 'background: #F9FAFB;border: 1px solid #E5E7EB;'"
                   @click="zbSelect(item)">
                  {{ item.label }}
              </div>
            </div>
            <div style="margin: 22px 0 16px 0;border: 2px solid #F3F4F6;border-radius: 4px 4px 4px 4px;"></div>
            <div style="">
              <div class="jyxx-content">
                <div v-for="(item,index) in zbList" :key="item.id" @click="ggDetail(item)">
                  <div style="display: flex;justify-content: space-between;align-items:center ;margin-bottom: 16px;box-sizing: border-box">
                    <div style="display: flex;justify-content: left;align-items: center">
                      <div style="width: 6px;height: 6px;background: #51A2FF;border-radius:25px;margin-right: 8px"></div>
                      <div style="font-size: 16px;color: #333333;font-weight: 400;" v-if="item.areaName">【{{ item.areaName }}】</div>
                      <div style="font-size: 16px;color: #333333;font-weight: 400;">{{ item.ggName.length > 40 ? item.ggName.substring(0,40) + '...' : item.ggName }}</div>
                    </div>
                    <div style="font-size: 14px;color: #99A1AF;">{{ item.ggStartTime.substring(0,10) }} </div>
                  </div>
                </div>

              </div>
              <div class="jyxx-foot" @click="toPath('/about')">
                <div style="font-weight: 500;font-size: 14px;color: #155DFC;cursor: pointer;margin-right: 4px"  >查看更多</div>
                <el-image style="width: 14px;height: 14px;" :src="require('@/assets/images/public/rightJT.png')"></el-image>
              </div>
            </div>
          </div>


        </div>
        <div class="jyxx" style="">
          <div class="jyxx-header">
            <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 6px">
              <div style="width: 64px;height: 1px; background: #BEDBFF;"></div>
              <div style="font-size: 28px;color: #1E2939;margin: 0 16px">下载中心</div>
              <div style="width: 64px;height: 1px; background: #BEDBFF;"></div>
            </div>
            <div style="font-weight: 500;font-size: 16px;">Download Center</div>
          </div>
          <div class="" style="display: flex;justify-content: left;align-items: center;flex-wrap: wrap;box-sizing: border-box">
            <div v-for="(item,index) in gjList" :key="item.id" style="display: flex;justify-content: left;align-items: center;cursor: pointer;flex-direction: column;margin-bottom: 12px;" :style="(index + 1) % 4 !== 0 ? 'margin-right: 20px' : ''">
              <div style="width:300px ;padding: 8px 12px;border: 1px solid #EEEEEE;border-radius: 4px;display: flex;justify-content: left;align-items: center;box-sizing: border-box" @click="downloadClick(item,index)">
                <el-image  style="width: 64px;height: 64px;margin-right: 12px" :src="item.imageUrl"></el-image>
                <div>
                  <div style="font-size: 18px;color: #333333;">{{ item.commonName }}</div>
                  <el-button style="font-size: 14px;color: #165DFF; " type="text" >点击下载</el-button>
                </div>
              </div>
            </div>
          </div>


        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {
  toolslist, getGgListNoPageApi,
} from "@/api/api";


import dlLogin from '@/assets/images/public/dlLogin.png'
import tbLogin from '@/assets/images/public/tbLogin.png'
import jdLogin from '@/assets/images/public/jdLogin.png'
import yzLogin from '@/assets/images/public/yzLogin.png'
import pbLogin from '@/assets/images/public/pbLogin.png'



export default {

  data: function () {
    return {
      logOn: [

        {icon: dlLogin,  title: "代理机构登录", path: "/login", type: '3', },
        {icon: tbLogin,  title: "投标人登录", path: "/login", type: '2', },
        {icon: jdLogin,  title: "监督/资审通道(新)", path: "/superviseLinks",},
        {icon: yzLogin, title: "业主登录", path: "/login", type: '1', },
        {icon: pbLogin, title: "评标专家登录", path: "/PBLoginMain",},
      ],
      cgType: [
        {label: "招标公告", value: 'zbgg'},
        {label: "变更公告", value: 'bggg'},
        {label: "资格预审公告", value: 'zgysgg'},
        {label: "供应商征集", value: 'GYS'},
        // {label: "专家征集",  value: 'ZJ'},
      ],
      cgList: [],
      cgQueryParam: {pageSize: 10, page: 1, ggAnnouncement: 'zbgg',},
      zbType: [
        {label: "中标候选人公示", value: 'zbhxrgs'},
        {label: "中标公告", value: 'zhongbiaogg'},
      ],
      zbList: [],
      zbQueryParam: {pageSize: 10, page: 1, ggAnnouncement: 'zbhxrgs',},
      gjList:[]
    };
  },
  created() {
    this.zoneId = `${process.env.VUE_APP_ZONID }`
    this.cgQueryParam.tenantId = this.zoneId
    this.zbQueryParam.tenantId = this.zoneId
  },
  mounted() {
    this.init()

  },
  methods: {
    async init(){
      await this.cg()
      await this.zb()
      await this.gj()
    },
    async cgSelect(val){
      this.cgQueryParam.ggAnnouncement=val.value
      await this.cg()
    },
    async cg(){
      const {data} = await getGgListNoPageApi(this.cgQueryParam)
      this.cgList = data || []
    },
    async zbSelect(val){
      this.zbQueryParam.ggAnnouncement = val.value
      await this.zb()
    },
    async zb(){
      const {data} =await getGgListNoPageApi(this.zbQueryParam)
      this.zbList = data || []
    },

    async gj(){
      const {data} = await toolslist()
      this.gjList = data.items || []
    },

    async goToLogin(val){
        if(val.path === '/PBLoginMain'){
          let url = location.origin + `${process.env.VUE_APP_PB_LOGOION}${this.zoneId}/index.html#/login`
          window.open(url, '_blank');
          return
        }
      if(val.path === '/superviseLinks'){
        let url = `https://supervise.gzzczb.com/#/login`
        window.open(url, '_blank');
        return
      }
        await this.$router.push({path: val.path,query:{type:val.type} })

    },
    toPath(val){
      this.$router.push({path: val,})
    },
    ggDetail(val,type){
      let path = '/ggDetail'
      if(val.ggAnnouncement === 'GYS' || val.ggAnnouncement === 'ZJ'){
        path = '/collectGgDetail'
      }
      let router =  this.$router.resolve({path: path, query: {id: val.id}});
      window.open(router.href, '_blank');
    },
    toRouter(val){
      let routeData = this.$router.resolve({path: val,});
      window.open(routeData.href, '_blank');
    },
    downloadClick(row) {
      window.open(row.commonTool)
    },
  },
};
</script>
<style scoped>
.page_home{
  box-sizing: border-box;
  background: #FFFFFF;
}
.home-main{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

}
.home-content{
  width:1260px;

}
.jyxx{
  margin: 32px 0;
}
.jyxx-header{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 28px;
  box-sizing: border-box;
}
.jyxx-content{
  min-height: 384px;
}
.jyxx-foot{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 14px;
}
.Itme{
  overflow: hidden;
  text-overflow: ellipsis; /* 设置文本溢出时显示省略号 */
  white-space: nowrap; /* 设置不换行 */
}
.bj{
  background: #FFFFFF;
  box-shadow: 0px 1px 2px -1px rgba(0,0,0,0.1), 0px 1px 3px 0px rgba(0,0,0,0.1);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #F3F4F6;
  padding: 24px;
  box-sizing: border-box;
}
</style>
